var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-primary"},[_vm._l((_vm.items),function(item,index){return [(item.type === 'divider')?_c('div',{key:`divider${index}`,staticClass:"bg-white w-1px h-15px ml-1 mr-2"}):_c('menu-item',_vm._b({key:index},'menu-item',item,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }